import api from "../axios/axios-config";

export const getPurchaseList = async () => {
  try {
    let response = await api.get(
      "purchaseList/listOfPurchaseList",

      
    );
    return response?.data?.data;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response?.data;
  }
};

export const addPurchaseList = async (data) => {
  try {
    let response = await api.post(
      "purchaseList/createPurchaseList",
      {
        ...data,
      },
      
    );
    return response?.data?.data;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response?.data;
  }
};

export const updatePurchaseList = async (dataId, data) => {
  try {
    let response = await api.post(
      "purchaseList/updatePurchaseList",
      {
        dataId,
        ...data,
      },
      
    );
    return response?.data?.data;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response?.data;
  }
};
